import { combineReducers, Reducer } from 'redux';

import { WalletState } from 'models/wallet';
import { walletAccountReducer } from 'reducers/wallet/account';
import { walletHistoryReducer } from 'reducers/wallet/history';
import { walletRedeemReducer } from 'reducers/wallet/redeem';
import { walletTopUpReducer } from 'reducers/wallet/topUp';
import { walletTransactionReducer } from 'reducers/wallet/transaction';
import { walletTransferReducer } from 'reducers/wallet/transfer';

export const walletReducer: Reducer<WalletState> = combineReducers<WalletState>({
  accountState: walletAccountReducer,
  historyState: walletHistoryReducer,
  redeemState: walletRedeemReducer,
  topUpState: walletTopUpReducer,
  transactionState: walletTransactionReducer,
  transferState: walletTransferReducer
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/wallet/index.ts